"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const styleOverrides = {
  root: ({
    ownerState: {
      variant
    },
    theme
  }) => ({
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.text.hover
    },
    ...(variant === 'button' && {
      textUnderlineOffset: '.25em',
      textDecorationThickness: '2px'
    })
  }),
  underlineAlways: {
    textDecorationColor: 'currentcolor'
  }
};
const defaultProps = {
  underline: 'always',
  variant: 'body1',
  color: 'textPrimary'
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
//# sourceMappingURL=MuiLink.js.map